'use client';

import { Pagination as DefaultPagination, PaginationContent } from '@/components/ui/pagination';
import { useGeneratePaginationLinks } from '@/utils/useGeneratePaginationLinks';
import useRouterTransition from '@/utils/useRouterTransition';
import { useParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

export default function Pagination(props) {
  const { page, pageCount, baseUrl, sectionId } = props;
  const { locale } = useParams();
  const router = useRouterTransition();

  const pages = useGeneratePaginationLinks(`/${locale}${baseUrl}`, page, pageCount, router.isPending, page => {
    router.push(`/${locale}${baseUrl}&page=${page}`);
  });

  const wasPending = useRef(false);

  useEffect(() => {
    const transitionJustFinished = wasPending.current && !router.isPending;
    wasPending.current = router.isPending;

    if (!transitionJustFinished) return;

    const scrollTarget = sectionId ? document.getElementById(sectionId) : window;

    scrollTarget?.scrollIntoView
      ? scrollTarget.scrollIntoView({ behavior: 'smooth' })
      : window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [router.isPending, sectionId]);


  if (pageCount <= 1) return <></>;

  return (
    <DefaultPagination className='mt-12'>
      <PaginationContent>{pages}</PaginationContent>
    </DefaultPagination>
  );
}
